import { useState } from 'react';
import { adminApi } from '../../api/admin';
import { useSession } from '../../auth/session';
import { Banner } from './ui';
import PushToggle from '../../components/PushToggle';

/** Admin's own account: profile details + change password. Nothing else. */
export default function AdminAccount() {
  const session = useSession();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const minLen = 6;
  const canSave = password.length >= minLen && password === confirm && !saving;

  async function save() {
    if (!session || !canSave) return;
    setSaving(true); setErr(''); setMsg('');
    try {
      await adminApi.changeOwnPassword(password);
      setPassword(''); setConfirm('');
      setMsg('Password changed. Use the new password next time you sign in.');
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Could not change the password.');
    } finally {
      setSaving(false);
    }
  }

  if (!session) return null;

  return (
    <div>
      <h1>My account</h1>

      <div className="card">
        <div className="row"><span className="k">Name</span><span className="v">{session.operatorName}</span></div>
        <div className="row"><span className="k">Employee ID</span><span className="v">{session.operatorId}</span></div>
        <div className="row"><span className="k">Role</span><span className="v" style={{ textTransform: 'capitalize' }}>{session.role}</span></div>
      </div>

      <PushToggle />

      <h2>Change password</h2>
      <Banner error={err} ok={msg || undefined} />
      <div className="card" style={{ maxWidth: 420 }}>
        <label>New password <span className="muted">(6+ characters)</span></label>
        <input type="password" autoComplete="new-password" value={password}
          onChange={(e) => setPassword(e.target.value)} />
        <label>Confirm new password</label>
        <input type="password" autoComplete="new-password" value={confirm}
          onChange={(e) => setConfirm(e.target.value)} />
        {confirm.length > 0 && password !== confirm && <p className="error tiny">Passwords don’t match.</p>}
        <button onClick={save} disabled={!canSave}>{saving ? 'Saving…' : 'Change password'}</button>
      </div>
    </div>
  );
}
